export { QRCode } from './QRCode'
